// extracted by mini-css-extract-plugin
export default {"container":"DF6oeMQUgkpAPmnQgTbb"};